export function AnnouncementBar() {
  return (
    <div className="bg-primary text-primary-foreground">
      <p className="label-xs mx-auto max-w-7xl px-4 py-2.5 text-center text-[0.55rem] tracking-[0.12em] opacity-90 sm:text-[0.65rem] sm:tracking-[0.2em]">
        Livraison partout au Maroc <span className="mx-2 text-accent">•</span> Paiement à la
        livraison
      </p>
    </div>
  );
}
